export const BREAKPOINT_DESKTOP = 'desktop'
export const BREAKPOINT_PHONE = 'phone'
export const BREAKPOINT_TABLET = 'tablet'

export const BREAKPOINT_LANDSCAPE = 'landscape'
export const BREAKPOINT_PORTRAIT = 'portrait'

export const BREAKPOINT_DESKTOP_WIDTH = 1025
export const BREAKPOINT_TABLET_WIDTH = 768